import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { Address } from 'src/app/models/Address';
import { AddressService } from 'src/app/services/address.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectUpdatePayload } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-address-input-modal',
  templateUrl: './address-input-modal.component.html',
  styleUrls: ['./address-input-modal.component.less']
})
export class AddressInputModalComponent implements OnInit, OnDestroy {

  @ViewChild('addressForm', {}) ngForm: NgForm;
  address: Address;
  model:any;
  saving: boolean = false;
  clientId: number;
  locationId: number;
  errorMessages : string[] = [];
  stateArray: Array<string> = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT',
    'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

  @Output() AddressSaved = new EventEmitter<Address>();
  constructor(public modalService: NgbModal, private addy: AddressService, private toast: ToastrService, private auth: AuthService) { }
  ngOnDestroy(): void {
    try {
      this.modalService.dismissAll();
    } catch (error) {

    }
  }

  ngOnInit() {

  }

  private isEditing(): boolean {
    return (this.address.clientId > 0 || this.address.clientLocationId > 0);
  }

  cancel() {
    this.modalService.dismissAll();
  }

  save() {
    if(this.saving) return;
    this.saving = true;
    //then it hasn't been saved yet and we're working on an existing entity..
    //note: if not editing, entity creation will handle building the address relationships
    this.errorMessages = [];
    if(!this.address.physical && !this.model.addresses.find(ad =>{return ad.physical;})){
      this.errorMessages.push('There must be a physical address');
    }else if(!this.address.physical && !this.address.billing){
      this.errorMessages.push('Please indicate if this is a billing of physical address.');
    }else if (this.address.physical && (this.model.addresses.filter(ad =>{return ad.physical;})).length >= 1) {
      //SCRSTP-1759: there should only be one physical address.. if one exists and a user is trying to add one, fail validation
      this.errorMessages.push('There may only be one physical address per location.');
    }

    if(this.errorMessages.length > 0) {
      this.saving = false;
      return;
    }
    
    if (this.ngForm.valid && this.errorMessages.length == 0 && this.saving) {
      if (this.address.id == 0 && this.isEditing) {
        this.addy.SaveNewAddress(this.address).subscribe((r: number) => {
          if (r > 0) //save successful
          {
            this.address.id = r;
            this.toast.success('Address saved successfully!', '');
            if(!this.address.isDefault) this.AddressSaved.emit(this.address);
            this.saving = false;
            this.modalService.dismissAll();
          }
          else {
            //unsuccessful, pop a toast
            this.toast.error('Error saving address!', '', { closeButton: true, disableTimeOut: true });
            this.saving = false;
          }
        })
      } else {
        //SCRSTP-1872: if this is a client address, we need to set the clientID so we can reference it on the BE for setting the client.lastModifiedDate
        if(this.clientId && this.clientId > 0) {
          this.address.clientId = this.clientId;
        }

        if(this.locationId && this.locationId > 0) {
          this.address.clientLocationId = this.locationId;
        }

        this.addy.UpdateAddress(this.address).subscribe(res => {
          this.toast.success('Address successfully updated!');
          this.saving = false;
          this.modalService.dismissAll();
        },
          err => {
            this.toast.error('Error updating address!', '', { disableTimeOut: true, closeButton: true });
            this.saving = false;
          });
      }
    }
    
  }
}
